import { render } from "./settings.vue?vue&type=template&id=56cad742"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"
script.render = render

export default script